import { render, staticRenderFns } from "./CreditNote.vue?vue&type=template&id=b1b9a624&scoped=true"
import script from "./CreditNote.vue?vue&type=script&lang=js"
export * from "./CreditNote.vue?vue&type=script&lang=js"
import style0 from "./CreditNote.vue?vue&type=style&index=0&id=b1b9a624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b9a624",
  null
  
)

export default component.exports